module.exports = __webpack_public_path__ + "media/components/video_discovery/assets/Account-04957d0336557fdccedada2755a4afca.svg";